import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    backButtonContainer: {
        alignItems: "center"
    },
    subtitle: {
        textAlign: "center"
    },
    formContainer: {
        width: "100%",
        maxWidth: 400
    }
});

export default stylesheet;
